import * as Sentry from '@sentry/browser';

import React from 'react';
import PropTypes from 'prop-types';
import PageError from '../pages/error/pageError';
import Template from './template/template';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //Reset of the state so that the menu continues to operate
        if (this.props.location !== prevProps.location) {
            this.setState({
                error: null,
                errorInfo: null
            });
        }
    }

    componentDidCatch(error, errorInfo) {
        // Configure error info and capture exception to sentry
        Sentry.configureScope(scope => {
            scope.setExtra('react_boundary_info', errorInfo);
        });

        Sentry.captureException(error);
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        // You can also log error messages to an error reporting service here
    }

    renderProduction() {
        return (
            <>
                {this.props.organization ? (
                    <PageError backHomeUrl={this.props.backHomeUrl} />
                ) : (
                    <Template>
                        <PageError />
                    </Template>
                )}
            </>
        );
    }

    renderDev() {
        return (
            <>
                {this.props.organization ? (
                    <PageError backHomeUrl={this.props.backHomeUrl} />
                ) : (
                    <Template>
                        <PageError />
                    </Template>
                )}
            </>
        );
    }

    render() {
        if (this.state.errorInfo) {
            if (process.env.NODE_ENV === 'production') {
                return this.renderProduction();
            } else {
                return this.renderDev();
            }
        }
        // Normally, just render children
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node
};
